$(document).ready(function () {
  $('.quad-background').each(function () {
    $(this).css('height', $(this).width());
    $(this).css('opacity', 1);
  });
  $(window).resize(function () {
    $('.quad-background').each(function () {
      $(this).css('height', $(this).width());
      $(this).css('opacity', 1);
    });
  });
  $('.collapsePersons').each(function () {
    var object = $(this);
    var hide = $('.hidden-ones').filter(function () {
      return $(this).attr('data-target') == object.attr('data-target');
    });
    hide.slideUp();
    $(this).click(function () {
      if (object.text() == 'mehr') {
        object.text("");
        object.append("<i class='fa fa-chevron-up'></i>weniger");
      } else {
        object.text("");
        object.append("mehr<i class='fa fa-chevron-down'></i>");
      }
      hide.slideToggle("slow");
      $('.quad-background').each(function () {
        $(this).css('height', $(this).width());
        $(this).css('opacity', 1);
      });
    });
  });
});
